import React, { ReactNode, useState } from 'react';
import { UserType } from './UserType';
import { getEnvLocalTenantType, UserTypeContext } from './UserTypeContext';

export const UserTypeContextContainer = (props: { children: ReactNode }): JSX.Element => {
    const [state, setState] = useState<UserType>({
        user: getEnvLocalTenantType(),
    });

    return (
        <UserTypeContext.Provider
            value={{
                value: state,
                setValue: setState,
            }}
        >
            {props.children}
        </UserTypeContext.Provider>
    );
};
